import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Skeleton from "@mui/material/Skeleton";
import { useAppStore } from "../appStore";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function PatientList() {
    const baseURL = process.env.REACT_APP_API_URL;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [formid, setFormid] = useState("");
    const updatePatient = useAppStore((state) => state.updatePatient);
    const updateHealers = useAppStore((state) => state.updateHealers);
    const updateYourPatients = useAppStore((state) => state.updateYourPatients);
    const token = useAppStore((state) => state.token);
    const utype = useAppStore((state) => state.utype);
    const uid = useAppStore((state) => state.uid);
    const useremail = useAppStore((state) => state.useremail);
    const navigate = useNavigate();
    const patient = useAppStore((state) => state.patient);
    const healers = useAppStore((state) => state.healers);

    useEffect(() => {
        if (!token) {
            navigate("/");
        }

        healersApi();
        getPatients();
        console.log("uhealer ", healers);
        if (utype == "Admin") {
            getUsers();
        } else if (utype == "Healer") {
            getHealerPatients();
        }
    }, []);

    const getHealerPatients = async () => {
        let posturl = baseURL + "healerpatient?que=" + useremail;
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updatePatient(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const getPatients = async () => {
        let posturl = baseURL + "patients";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updateYourPatients(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const healersApi = async () => {
        let posturl = baseURL + "healer";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updateHealers(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const getUsers = async () => {
        let posturl = baseURL + "patient";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updatePatient(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const deleteUser = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.value) {
                deleteApi(id);
            }
        });
    };

    const sendMessage = (row) => {
        var url =
            "https://wa.me/"+row.mobile+"?text=" +
            "Namaste " +
            row.name +
            "%0a" +
            "Please check your report at: " +
            "%0a" +
            "https://admin.goldenmiraclesenergyhealingconsultancy.com/" +
            "%0a";
        window.open(url, "_blank").focus();
        // https://tempty.in/api/send.php?number=918789529215&type=text&message=test%20message&instance_id=644560DF79978&access_token=089820845cdc84ff06a64c970ff82c72 
    };

    const deleteApi = async (id) => {
        let posturl = baseURL + "patient/" + id;
        await axios
            .delete(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(function (res) {
                console.log(res.data);
                getUsers();
                Swal.fire(
                    "Submitted!",
                    "Your file has been submitted.",
                    "success"
                );
            })
            .catch(function (error) {
                console.log("kcheckpost" + error); //return 429
            });
    };

    const filterData = (v) => {
        if (v) {
            updatePatient([v]);
        } else {
            getUsers();
        }
    };

    const editData = (
        id,
        name,
        user_id,
        gender,
        age,
        country,
        occupation,
        address,
        mobile,
        type,
        status,
        description,
        any_addictions,
        healer_id,
        symptom_id,
        tags
    ) => {
        const data = {
            id: id,
            name: name,
            user_id: user_id,
            gender: gender,
            age: age,
            country: country,
            occupation: occupation,
            address: address,
            mobile: mobile,
            type: type,
            status: status,
            description: description,
            any_addictions: any_addictions,
            healer_id: healer_id,
            symptom_id: symptom_id,
            tags: tags,
        };
        setFormid(data);
        navigate("/edit-patient", {
            state: {
                id: id,
                name: name,
                user_id: user_id,
                gender: gender,
                age: age,
                country: country,
                occupation: occupation,
                address: address,
                mobile: mobile,
                type: type,
                status: status,
                description: description,
                any_addictions: any_addictions,
                healer_id: healer_id,
                symptom_id: symptom_id,
                tags: tags,
            },
        });
    };

    return (
        <>
            <Paper sx={{ width: "98%", overflow: "hidden", padding: "12px" }}>
                <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{ padding: "20px" }}
                >
                    Patients
                </Typography>
                <Divider />
                <Box height={10} />
                <Stack direction="row" spacing={2} className="my-2 mb-2">
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={patient}
                        sx={{ width: 300 }}
                        onChange={(e, v) => filterData(v)}
                        getOptionLabel={(patient) => patient.email || ""}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label="Search"
                            />
                        )}
                    />

                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}
                    ></Typography>
                    <Button
                        variant="contained"
                        endIcon={<AddCircleIcon />}
                        onClick={() => {
                            navigate("/add-patient");
                        }}
                    >
                        Add
                    </Button>
                </Stack>
                <Box height={10} />
                {patient.length > 0 && (
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Patient
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Healer
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Healer Level
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Mobile
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Type
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Status
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Created At
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {patient
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={index}
                                            >
                                                <TableCell align="left">
                                                    {row.email}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {row.healer_email}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {row.symptom_id}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {row.mobile}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {row.type}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {String(row.status)}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {moment(
                                                        row.created_at
                                                    ).format("MMMM Do YYYY")}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Stack
                                                        spacing={2}
                                                        direction="row"
                                                    >
                                                        <EditIcon
                                                            style={{
                                                                fontSize:
                                                                    "20px",
                                                                color: "blue",
                                                                cursor: "pointer",
                                                            }}
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                                editData(
                                                                    row.id,
                                                                    row.name,
                                                                    row.user_id,
                                                                    row.gender,
                                                                    row.age,
                                                                    row.country,
                                                                    row.occupation,
                                                                    row.address,
                                                                    row.mobile,
                                                                    row.type,
                                                                    row.status,
                                                                    row.description,
                                                                    row.any_addictions,
                                                                    row.healer_id,
                                                                    row.symptom_id,
                                                                    row.tags
                                                                );
                                                            }}
                                                        />
                                                        <WhatsAppIcon
                                                            style={{
                                                                fontSize:
                                                                    "20px",
                                                                color: "green",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => {
                                                                sendMessage(
                                                                    row
                                                                );
                                                            }}
                                                        />
                                                        <DeleteIcon
                                                            style={{
                                                                fontSize:
                                                                    "20px",
                                                                color: "darkred",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => {
                                                                deleteUser(
                                                                    row.id
                                                                );
                                                            }}
                                                        />
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={patient.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

            {patient.length == 0 && (
                <>
                    <Paper
                        sx={{
                            width: "98%",
                            overflow: "hidden",
                            padding: "12px",
                        }}
                    >
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={30}
                        />
                        <Box height={40} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                    </Paper>
                </>
            )}
        </>
    );
}
